var map = {
	"./icon0.png": "fac3",
	"./icon0_a.png": "395a",
	"./icon1.png": "d72c",
	"./icon1_a.png": "bc22",
	"./icon2.png": "6cb6",
	"./icon2_a.png": "5c3e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb92";